var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-wiki-draft-list.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { View } from "@adornis/data-view/db/view.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { StringAspect } from "@adornis/filter/aspect-schemas/StringAspect.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { WikiEntryDraft, WikiEntryDraftStatus } from "../db/WikiEntryDraft.js";
var XWikiDraftList = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    /** Translation controller for wiki-specific translations */
    this.t = new TranslationController(this);
    this.referenceID = "";
    this.noTitle = false;
  }
  render() {
    if (!this.referenceID) {
      return "";
    }
    return xComponents(html`
      ${this.noTitle ? nothing : xComponents(html`<x-flex
            slot="title"
            space-between
            center
            horizontal
            ${css({
      borderBottom: "1px solid rgba(0,0,0,0.1)",
      paddingBottom: this.spacing.sm,
      marginBottom: this.spacing.sm
    })}
          >
            <x-h3>${this.t.translate("wiki", "draft")}</x-h3>
          </x-flex>`)}

      <x-data-view
        .options=${{
      class: WikiEntryDraft,
      isEntryClickable: true,
      view: new View({
        filter: new AdornisFilter({
          aspects: [
            new StringAspect({
              fieldName: "referenceID",
              mode: "containsOR",
              value: this.referenceID
            })
          ]
        })
      }),
      customColumns: [
        { fieldName: "title" },
        {
          fieldName: "createdAt",
          getFieldMapping: (ent) => {
            return xComponents(html` <x-text>${ent.createdAt?.toFormat("dd.MM.yyyy HH:mm")}</x-text> `);
          }
        },
        {
          fieldName: "modifiedAt",
          columnWidth: "max-content",
          selectionSet: { modifiedAt: 1, modifiedByID: 1 },
          getFieldMapping: (ent) => {
            return xComponents(html`<x-flex horizontal space="sm">
                  <x-text>${ent.modifiedAt?.toFormat("dd.MM.yyyy HH:mm")}</x-text>
                  <x-text><x-wiki-user-text .userID=${ent.modifiedByID}></x-wiki-user-text></x-text>
                </x-flex>`);
          }
        },
        {
          fieldName: "status",
          getFieldMapping: (ent) => {
            return WikiEntryDraftStatus[ent.status];
          }
        }
      ]
    }}
        @entry-clicked=${(event) => {
      this.dispatchEvent(
        new CustomEvent("entry-navigate", {
          detail: {
            value: event.detail.entity._id,
            edit: false
          }
        })
      );
    }}
      ></x-data-view>
    `);
  }
};
__decorateClass([
  property({ attribute: false })
], XWikiDraftList.prototype, "referenceID", 2);
__decorateClass([
  property({ type: Boolean, attribute: "no-title" })
], XWikiDraftList.prototype, "noTitle", 2);
XWikiDraftList = __decorateClass([
  customElement("x-wiki-draft-list")
], XWikiDraftList);
export {
  XWikiDraftList
};
